import classNames from 'classnames';
import { ServiceOfferingBlock } from '@sapientpro/sapientpro-data-models';
import { useMemo, useRef } from 'react';
import styles from './ServicesSection.module.scss';
import Img from '../Img';
import AuthorCard from '../../page-components/Home/Reviews/ReviewAuthor';

interface ITextCardProps {
  data: ServiceOfferingBlock;
}

const TextCard = ({ data }: ITextCardProps) => {
  const quoteContent = useMemo(() => {
    const searchRegExp = /\*\*([^*]+)\*\*/g;
    return data?.quote?.replace(searchRegExp, '<mark>$1</mark>');
  }, [data.quote]);
  const cardRef = useRef<HTMLDivElement>(null);

  const handleAnimation = (isHovered: boolean) => {
    if (cardRef.current) {
      if (isHovered) {
        cardRef.current.classList.remove(styles.quoteHidden);
        cardRef.current.classList.add(styles.quoteShown);
      } else {
        cardRef.current.classList.remove(styles.quoteShown);
        cardRef.current.classList.add(styles.quoteHidden);
      }
    }
  };

  const ellipseSrc = data.color !== 'light' ? '/media/ellipses/elps_grain_dark.svg' : '/media/ellipses/elps_grain_light.svg';

  return (
    <div
      className={classNames(styles.textCard, styles[data.color])}
      ref={cardRef}
      onMouseEnter={() => handleAnimation(true)}
      onMouseLeave={() => handleAnimation(false)}
    >
      <div className={styles.cardDecoration}>
        <Img
          src={ellipseSrc}
          alt='ellipse'
          width={18}
          height={18}
          className={styles.cardEllipse}
          priority={false}
        />
        <svg
          width={24}
          height={24}
          className={styles.cardArrow}
        >
          <use
            xlinkHref='/media/icon-nest.svg#iconNest'
            href='/media/icon-nest.svg#iconNest'
          />
        </svg>
      </div>
      <div className={styles.textWrapper}>
        <p className={classNames(styles.cardTitle, 'header3')}>{data.title}</p>
        <p className={classNames(styles.description, 'bodyLarge')}>{data.description}</p>
      </div>
      <p
        className={classNames(styles.quote, 'header4')}
        dangerouslySetInnerHTML={{ __html: quoteContent }}
      />
      {!!data.author && (
      <AuthorCard
        avatar={data?.author?.avatar}
        name={data?.author?.name}
        position={data?.author?.position}
        className={styles.quoteAuthor}
        positionClassName={styles.quoteAuthorPosition}
      />
      )}
    </div>
  );
};

export default TextCard;
